import { Info } from 'react-feather';

import { useAppContext } from '@/context';
import { useEffectOnce } from '@/hooks';
import { useTranslation } from 'react-i18next';

import styles from './Alert.module.css';

const SHOW_INFO = [
  {
    alert: 'INSTAGRAM_BUSINESS_ACCOUNT_REQUIRED',
    link: 'https://help.instagram.com/2358103564437429'
  }
];

export function Alert() {
  const { alert, setAlert } = useAppContext();
  const { t } = useTranslation();

  const hasInfo = SHOW_INFO.find((info) => info.alert === alert);

  function handleClose() {
    if (hasInfo) {
      window.open(hasInfo.link);
    }

    setAlert('');
  }

  useEffectOnce(() => {
    if (!hasInfo) {
      setTimeout(() => setAlert(''), 3001);
    }
  }, [alert, setAlert]);

  if (!alert) return null;

  return (
    <button
      data-has-info={!!hasInfo}
      className={styles.alert}
      onClick={handleClose}
      data-alert={alert}
      type="button"
    >
      {t(`alert.${alert}`)}
      {!!hasInfo && <Info size={16} aria-label={t('aria.info')} />}
    </button>
  );
}
